import MenuItem from './MenuItem'

export default MenuItem
// eslint-disable-next-line import/export
export * from './MenuItem'
